<div class="relative flex mdMax:flex-col lg:flex-row flex-auto">
  <div
    *ngIf="isMobile$ | async"
    class="absolute flex justify-center items-center px-4 py-3 gap-x-2 w-full"
    style="z-index: 1"
  >
    <div class="flex flex-col">
      <app-input-text-atom
        [label]="textInputLabel | translate"
        [iconRight]="textInputIcon"
        [cross]="true"
        [value]="filterAddress$ | async"
        (iconClick)="getCurrentPosition()"
        (valueChange)="onClear($event)"
      >
      </app-input-text-atom>
      <div
        *ngIf="geolocateError?.length"
        class="py-2 mt-2 text-error-700 font-base bg-white rounded text-sm text-center"
      >
        {{ geolocateError }}
      </div>
    </div>
    <app-rounded-icon-button
      [icon]="filterIcon"
      (onClick)="openFiltersModal()"
    ></app-rounded-icon-button>
    <!-- <app-rounded-icon-button [icon]='searchIcon'></app-rounded-icon-button> -->
  </div>

  <div
    *ngIf="!(isMobile$ | async)"
    class="flex flex-col p-6 min-w-1/4 max-w-3/7 overflow-y-auto"
  >
    <div class="flex gap-3">
      <app-button-atom
        *ngIf="!(isMobile$ | async)"
        [type]="'light'"
        [icon]="filterIcon"
        [label]="filterButtonLabel | translate"
        (clickEventEmitter)="openFiltersModal()"
      >
      </app-button-atom>
      <!-- <app-rounded-icon-button [icon]='searchIcon'></app-rounded-icon-button> -->
    </div>
    <h1 class="font-accent font-bold text-28px leading-8.5 pb-4 pt-5">
      {{ 'shop-list-header.title' | translate }}
    </h1>
    <div class="divide-y divide-neutral-300 flex flex-col max-h-45-screen">
      <div
        *ngFor="let shop of shops"
        class="py-3 first:pt-0"
        (click)="navigateToShopPage(shop)"
      >
        <app-push-shop-atom
          [name]="shop[entityKeys.Name]"
          [category]="shop[entityKeys.Type]?.name"
          [distance]="shop[entityKeys.Distance]"
          [budget]="shop.pricing"
          [shop]="shop"
        >
        </app-push-shop-atom>
      </div>
      <ng-container *ngIf="isGetShopLoading && !shops.length">
        <div
          *ngFor="let j of [].constructor(8)"
          class="flex"
        >
          <div class="animate-pulse w-24 h-24 bg-neutral-300 rounded mr-2 my-2"></div>
          <div class="w-2/4 my-2">
            <p class="w-full bg-neutral-400 h-4 animate-pulse mb-2"></p>
            <p class="w-3/4 bg-neutral-300 h-3 animate-pulse mb-2"></p>
            <p class="w-1/4 bg-neutral-300 h-2 animate-pulse mb-2"></p>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="flex-auto">
    <google-map
      width="100%"
      height="100%"
      class="h-full"
      *ngIf="isMapApiLoaded"
      [options]="mapOptions"
    >
      <map-marker
        [icon]="currentMarkerIcon"
        *ngIf="currentMarkerPosition"
        [position]="currentMarkerPosition"
      ></map-marker>
      <map-marker
        [icon]="selectedMarkerIcon"
        *ngIf="selectedMarkerPosition"
        [options]="selectedMarkerOptions"
        [position]="selectedMarkerPosition"
      ></map-marker>
      <map-marker-clusterer
        [styles]="clusterStyles"
        [maxZoom]="clusterMaxZoom"
        [imagePath]="clusterImagePath"
        [minimumClusterSize]="clusterMinimumSize"
      >
        <ng-container *ngFor="let marker of markers">
          <map-marker
            [position]="marker"
            [icon]="neutralMarkerConfig"
            *ngIf="isMarkerVisible(marker)"
            (mapClick)="selectMarker($event)"
          ></map-marker>
        </ng-container>
      </map-marker-clusterer>
    </google-map>
  </div>

  <div class="sticky bottom-10 flex flex-col">
    <div
      class="absolute right-0 flex flex-row-reverse p-4"
      [ngClass]="isShopSideScrollingListVisible && (isMobile$ | async) ? 'bottom-28' : 'bottom-4'"
    >
      <app-rounded-icon-button
        *ngIf="isMobile$ | async"
        type="normal"
        [icon]="bulletListIcon"
        (onClick)="navigateToShopList()"
      >
      </app-rounded-icon-button>
      <app-button-atom
        class="shrink-0"
        *ngIf="!(isMobile$ | async)"
        [type]="'primary'"
        [icon]="bulletListIcon"
        [label]="bulletListButtonLabel | translate"
        (clickEventEmitter)="navigateToShopList()"
      >
      </app-button-atom>
    </div>

    <div
      #shopSideScrollingList
      *ngIf="shops.length && isShopSideScrollingListVisible && (isMobile$ | async)"
      class="absolute bottom-4 gap-2 w-full flex snap-x overflow-x-auto"
    >
      <div
        *ngFor="let shop of shops"
        class="snap-center shrink-0 first:pl-5 last:pr-5 h-24 w-11/12 inline-block rounded"
        (click)="navigateToShopPage(shop)"
      >
        <app-push-shop-atom
          [name]="shop[entityKeys.Name]"
          [category]="shop[entityKeys.Type]?.name"
          [distance]="shop[entityKeys.Distance]"
          [budget]="shop.pricing"
          [shop]="shop"
        >
        </app-push-shop-atom>
      </div>
    </div>
  </div>

  <div class="lg:hidden sticky bottom-0">
    <app-shop-search-parameters-overview></app-shop-search-parameters-overview>
  </div>
</div>
